<template>
<Layout>
	<h1>
		<BaseIcon name="user" />
		{{ user.name }}
		Profile
	</h1>
	<pre>{{ user }}</pre>
</Layout>
</template>

<script>
import Layout from 'layouts/main';

export default {
	page() {
		return {
			title: this.user.name,
			meta: [
				{
					name: 'description',
					content: `The user profile for ${this.user.name}.`,
				},
			],
		};
	},
	components: { Layout },
	props: {
		user: {
			type: Object,
			required: true,
		},
	},
};
</script>

<style lang="scss" scoped>
@import 'theme.scss';

pre {
  color: $color-action;
}
</style>

<style lang="scss" scoped>
pre {
  font-size: 2rem;
  line-height: 2.5rem;
}
</style>

<style lang="scss" scoped>




</style>

<style lang="scss" scoped>





</style>
